// TemperatureLabels.js
export const TemperatureLabels = (temperature, isMetric = null) => {
  if (!temperature) return "No Record Added";

  // If isMetric is explicitly provided (true/false)
  if (isMetric !== null) {
    const unit = isMetric ? "°C" : "°F";
    let colorClass = "";
    if (isMetric) {
      if (temperature >= 36.1 && temperature <= 37.2) colorClass = "text-green-500";
      else if (temperature > 37.2) colorClass = "text-red-500";
      else colorClass = "text-blue-500";
    } else {
      if (temperature >= 97 && temperature <= 99) colorClass = "text-green-500";
      else if (temperature > 99) colorClass = "text-red-500";
      else colorClass = "text-blue-500";
    }
    return <p className={colorClass}>{temperature}{unit}</p>;
  }

  // Fallback to legacy guessing logic if isMetric is not provided
  if (temperature >= 100 && temperature <= 110) {
    return <p className="text-red-500">{temperature}°F</p>;
  } else if (temperature >= 90 && temperature <= 100) {
    return <p className="text-green-500">{temperature}°F</p>;
  } else if (temperature >= 30 && temperature < 40) {
    return <p className="text-green-500">{temperature}°C</p>;
  } else if (temperature >= 40 && temperature <= 45) {
    return <p className="text-red-500">{temperature}°C</p>;
  } else {
    return <p>{temperature}°</p>;
  }
};

export const OxygenSaturationLabels = (oxygen) => {
  if (!oxygen) return "No Record Added";

  if (oxygen >= 95) {
    return <p className="text-green-500">{oxygen}%</p>;
  } else if (oxygen > 92 && oxygen < 95) {
    return <p className="text-yellow-400">{oxygen}%</p>;
  } else {
    return <p className="text-red-500">{oxygen}%</p>;
  }
};
